import { gql } from '@apollo/client';

export default gql`
  query getSalesforceTrainData($trainNumber: String!, $departureDate: String!) {
    getSalesforceTrainData(trainNumber: $trainNumber, departureDate: $departureDate) {
      trainNumber
      departureDate
      isCancelled
    }
  }
`;
